import { useState } from "react";
import BackgroundGradient from "@/components/landing/BackgroundGradient";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import ContactModal from "@/components/landing/ContactModal";
import SEO from "@/components/SEO";

export default function Cookies() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
    <BackgroundGradient />
    <div style={{ minHeight: "100vh", color: "var(--dyna-fg)", position: "relative", zIndex: 1 }}>
      <SEO
        title="Cookie Policy — Dyna Agency"
        description="What cookies Dyna Agency uses and how to manage them."
        path="/cookies"
      />
      <Navbar onCTA={() => setModalOpen(true)} />
      <main style={{ paddingTop: 100 }}>
        <div className="dyna-policy-page">

          <h1>Cookie Policy</h1>
          <span className="dyna-policy-updated">Last updated: April 2026</span>

          <div className="dyna-policy-section">
            <h2>1. What Are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device when you visit a website.
              They help websites remember your preferences, keep you logged in, and
              understand how you use the site so we can improve it.
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>2. Cookies We Use</h2>

            <h2 style={{ fontSize: 16, marginTop: "var(--s-sm)", textTransform: "none", letterSpacing: "0.06em", color: "var(--dyna-fg)" }}>
              Essential — cannot be disabled
            </h2>
            <ul>
              <li>
                <strong>Session cookie</strong> — keeps you logged in to your client
                portal during your visit. Expires when you close your browser.
              </li>
              <li>
                <strong>Google OAuth token</strong> — required for Google sign-in.
                Set by Google; governed by{" "}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  Google's Privacy Policy
                </a>.
              </li>
            </ul>

            <h2 style={{ fontSize: 16, marginTop: "var(--s-sm)", textTransform: "none", letterSpacing: "0.06em", color: "var(--dyna-fg)" }}>
              Analytics — help us improve
            </h2>
            <ul>
              <li>
                <strong>Google Analytics</strong> (<code>_ga</code>, <code>_gid</code>) —
                anonymized usage tracking: pages visited, time on site, referring pages,
                browser type. No personally identifiable information is stored.
              </li>
            </ul>
            <p>
              Opt out of Google Analytics:{" "}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
                tools.google.com/dlpage/gaoptout
              </a>
            </p>

            <h2 style={{ fontSize: 16, marginTop: "var(--s-sm)", textTransform: "none", letterSpacing: "0.06em", color: "var(--dyna-fg)" }}>
              Preference — remember your settings
            </h2>
            <ul>
              <li>
                <strong>dyna-theme</strong> — remembers your light or dark mode
                preference across visits.
              </li>
              <li>
                <strong>dyna-lang</strong> — remembers your language preference
                (English or Hebrew).
              </li>
            </ul>
          </div>

          <div className="dyna-policy-section">
            <h2>3. Third-Party Cookies</h2>
            <ul>
              <li>
                <strong>Google Analytics</strong> — set by Google to provide anonymized
                analytics. See{" "}
                <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">
                  Google's cookie policy
                </a>.
              </li>
              <li>
                <strong>Stripe</strong> — set on checkout pages only for fraud prevention
                and payment processing. See{" "}
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">
                  Stripe's privacy policy
                </a>.
              </li>
            </ul>
          </div>

          <div className="dyna-policy-section">
            <h2>4. How to Manage Cookies</h2>
            <p>
              You can control and delete cookies through your browser settings. Note that
              disabling essential cookies may prevent parts of the site from working correctly.
            </p>
            <ul>
              <li>
                <strong>Chrome</strong>: Settings → Privacy and Security → Cookies and other site data
              </li>
              <li>
                <strong>Firefox</strong>: Settings → Privacy &amp; Security → Cookies and Site Data
              </li>
              <li>
                <strong>Safari</strong>: Preferences → Privacy → Manage Website Data
              </li>
              <li>
                <strong>Edge</strong>: Settings → Cookies and site permissions
              </li>
            </ul>
          </div>

          <div className="dyna-policy-section">
            <h2>5. Contact</h2>
            <p>
              Questions about our use of cookies?{" "}
              <a href="mailto:hello@dyna-agency.com">hello@dyna-agency.com</a>
              {" "}|{" "}
              <a href="https://www.dyna-agency.com" target="_blank" rel="noopener noreferrer">
                www.dyna-agency.com
              </a>
            </p>
          </div>

        </div>
      </main>
      <Footer />
    </div>
    <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
